import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component.js';
import { mainProviders } from './main-provider.js';

const clientOnlyProviders = [...mainProviders] as any;

bootstrapApplication(AppComponent, {
  providers: clientOnlyProviders,
});
